export const APP_VERSION = "2026.05.18";
export default APP_VERSION;
